"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _globals = require("../../../globals.js");

function _default(palette) {
  var _ref;

  return _ref = {
    palette: palette,
    fontFamily: palette.fontFamily,
    fontSize: palette.tsXSmall,
    lineHeight: palette.tlXSmall,
    overflow: 'visible',
    textAlign: 'left',
    padding: 0,
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    transitionProperty: 'color, transform',
    transformOrigin: '0 0',
    color: palette.tLabel
  }, (0, _defineProperty2["default"])(_ref, _globals.STATE.HOVER, {
    color: palette.tLabel
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.FOCUS, {
    color: palette.tAccent
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.ERROR, {
    color: palette.tError
  }), (0, _defineProperty2["default"])(_ref, _globals.STATE.DISABLED, {
    color: palette.tLabel
  }), _ref;
}